import { utilBuildings } from "../../../utils/utilBuildings";
export var selectBuildingMaxStage = function (buildings) {
    return buildings.sort(function (oldBuilding, newBuilding) {
        return utilBuildings.getProtoStage(oldBuilding) - utilBuildings.getProtoStage(newBuilding);
    })[buildings.length - 1];
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingMaxStage.ts
// module id = 898
// module chunks = 3